import { Permission } from '@src/domain/rbac/entities/permission.entity';
import type { PermissionDTO } from '../dto/permission.dto';

/**
 * Permission Mapper
 * Converts between Permission domain entity and PermissionDTO
 */
export class PermissionMapper {
    /**
     * Convert DTO to Domain Entity
     */
    static toDomain(dto: PermissionDTO): Permission {
        return Permission.create({
            permissionId: dto.permission_id,
            name: dto.name,
            resource: dto.resource,
            action: dto.action,
            description: dto.description,
            createdAt: new Date(dto.created_at),
            updatedAt: new Date(dto.updated_at),
        });
    }

    /**
     * Convert Domain Entity to DTO
     */
    static toDTO(permission: Permission): PermissionDTO {
        const props = permission.toJSON();
        return {
            permission_id: props.permissionId,
            name: props.name,
            resource: props.resource,
            action: props.action,
            description: props.description,
            created_at: props.createdAt.toISOString(),
            updated_at: props.updatedAt.toISOString(),
        };
    }

    /**
     * Convert array of DTOs to Domain Entities
     */
    static toDomainList(dtos: PermissionDTO[]): Permission[] {
        return dtos.map(dto => this.toDomain(dto));
    }

    /**
     * Convert array of Domain Entities to DTOs
     */
    static toDTOList(permissions: Permission[]): PermissionDTO[] {
        return permissions.map(permission => this.toDTO(permission));
    }
}
